import type {DataTableFilterMeta, DataTablePageEvent} from 'primevue/datatable'
import type {DataViewPageEvent} from 'primevue/dataview'
import type {ToastServiceMethods} from 'primevue/toastservice'
import type {TreeTableSortMeta} from 'primevue'
import type { FormFieldState } from '@primevue/forms/form'
import * as yup from 'yup'

export const getCookie = (name: string): string | undefined => {
  if (!import.meta.client) return

  const value = document.cookie
    .split('; ')
    .find((row) => row.startsWith(name + '='))
    ?.split('=')[1]
  return value ? decodeURIComponent(value) : undefined
}

export const getFiltersValue = (filters: DataTableFilterMeta) => {
  const newFilters: Record<string, string|undefined> = {}

  Object.keys(filters).forEach((key: string) => {
    const filter = filters[key]

    if (typeof filter === 'string') {
      newFilters[key] = filter
    // @ts-expect-error "Extected error"
    } else if ('value' in filter) {
      let value = filter.value
      if (value && Object.hasOwn(value, 'id')) value = value.id
      newFilters[key] = value
    }
  })

  return newFilters
}

export const getSortValue = (sort: TreeTableSortMeta) => {
  if (sort.order === 1) return { o: sort.field }
  if (sort.order === -1) return { o: `-${sort.field}` }

  return {}
}

export const getPagination = (event: DataTablePageEvent|DataViewPageEvent) => ({
  page: event.page + 1,
  per_page: event.rows
})

export const processFormErrors = (
  error: any,
  toast: ToastServiceMethods,
  states?: Record<string, FormFieldState>
) => {
  if (!error || !error.data) return

  states = states ?? {}

  for (const [key, value] of Object.entries(error.data)) {
    if (states[key]) {
      states[key].errors = Array.isArray(value) ? value : [value]
      states[key].invalid = true
      states[key].valid = false
    } else if (key === 'non_field_errors') {
      if (Array.isArray(value)) {
        value.forEach((message) => {
          toast.add({
            life: 5000,
            severity: 'error',
            summary: 'Error',
            detail: message,
          })
        })
      } else {
        toast.add({
          life: 5000,
          severity: 'error',
          summary: 'Error',
          detail: value,
        })
      }
    } else if (key === 'detail') {
      toast.add({
        life: 5000,
        severity: 'error',
        summary: 'Error',
        detail: value,
      })
    } else {
      if (Array.isArray(value)) {
        value.forEach((message) => {
          toast.add({
            life: 5000,
            severity: 'error',
            summary: 'Error',
            detail: message,
          })
        })
      } else {
        toast.add({
          life: 5000,
          severity: 'error',
          summary: 'Error',
          detail: value,
        })
      }
    }
  }
}

export const setupHeaders = (headers: Headers) => {
  const csrfToken = getCookie('csrftoken')

  if (csrfToken) {
    if (Array.isArray(headers)) {
      headers.push(['X-CSRFToken', csrfToken])
    } else if (headers instanceof Headers) {
      headers.set('X-CSRFToken', csrfToken)
    }
  }

  return headers
}

export type FormSubmitProps = {
  label?: string
  icon?: string
  severity?: string
}

export type FormField = {
  as: string
  name: string
  label?: string
  listeners?: Record<string, any>
  schema: yup.Schema
  [key: string]: any
}
